const TransformerLightValues = Object.freeze({
    base: {
        default: '#3B8CE2',
        action: '#3B8CE2',
        active: '#3B8CE2',
        activeAction: '#3B8CE2',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});
const TransformerDarkValues = Object.freeze({
    base: {
        default: '#3B8CE2',
        action: '#3B8CE2',
        active: '#3B8CE2',
        activeAction: '#3B8CE2',
    },
    text: {
        default: '#ffffff',
        action: '#ffffff',
        active: '#ffffff',
        activeAction: '#ffffff',
    },
});

export { TransformerDarkValues, TransformerLightValues };
